import { render, staticRenderFns } from "./Overtheworld.vue?vue&type=template&id=6a9a0d80&scoped=true"
import script from "./Overtheworld.vue?vue&type=script&lang=js"
export * from "./Overtheworld.vue?vue&type=script&lang=js"
import style0 from "./Overtheworld.vue?vue&type=style&index=0&id=6a9a0d80&prod&lang=css"
import style1 from "./Overtheworld.vue?vue&type=style&index=1&id=6a9a0d80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9a0d80",
  null
  
)

/* custom blocks */
import block0 from "./Overtheworld.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports